/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { Card, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors, CardHeader, Tooltip, IconButton } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { GetTemplate } from '../../actions/PCIsReportActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	},
	buttons: {
		downloadBtn: {
			backgroundColor: colors.green[600],
			display: 'flex',
			justifyContent: 'flex-end',
			'&:hover': {
				backgroundColor: colors.green[900]
			}
		}
	},
	cardContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	}
}));

const PCIsTemplate = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user);

	const _TemplateFileDownload = file => {
		dispatch(GetTemplate(user.id));
	};

	return (
		<Page className={classes.root}>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="Template File" />
					<Divider className={classes.divider} orientation="vertical" />
					<CardContent className={classes.cardContent}>
						<div className={classes.cardContent}>
							<InsertDriveFileOutlinedIcon />
							<span style={{ marginLeft: '10px' }}>Download template excel file</span>
						</div>
						<Tooltip title="Download file">
							<IconButton
								color="primary"
								className={classes.iconButton}
								onClick={_TemplateFileDownload}
								aria-label="downloadfile"
								size="large"
							>
								<FileDownloadOutlinedIcon />
							</IconButton>
						</Tooltip>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default PCIsTemplate;
